import { notifications } from "@mantine/notifications";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";
import { masterclassQKeys } from "@hooks/queries/masterclass/queryKeys";

import { Masterclass } from "@customTypes/masterclass";

export interface CreateMasterclassPayload {
  name: string;
  datetime: string;
  price: number;
  provider_id: string;
  slug: string;
  banner?: string;
  description?: string;
}

export const useCreateMasterclass = () => {
  const queryClient = useQueryClient();
  const handleErrors = useQueryErrorHandling();

  return useMutation({
    mutationFn: async (payload: FormData) => {
      const { data } = await api.post<Masterclass>("masterclass/", payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return data;
    },
    onSuccess: () => {
      notifications.show({
        title: "Success",
        message: "Masterclass created successfully",
        color: "green",
      });
      queryClient.invalidateQueries({
        queryKey: masterclassQKeys.classes(),
      });
    },
    onError: (res: any) => {
      console.error("[From Create Masterclass Mutation]", res);
      handleErrors(res, "mutation");
    },
  });
};
